<template>
  <div
    ref="test"
    @click="onHotspotClick"
    class="hotspot-container"
  >
    <HotspotPulse v-if="hotspot && hotspot._slug !== 'block' && hotspot._slug !== 'osteria-website' && !premium" class="pulse" :small="small"/>

    <div class="block absolute-center" v-if="hotspot && hotspot._slug === 'block'" @click="showText = !showText">
      <div class="circle absolute-center" :class="{ 'block-circle': hotspot._slug === 'block'}">
        <IconNoAccess v-if="!showText" class="icon absolute-center"></IconNoAccess>
        <span class="absolute-center" v-if="showText">{{hotspot[$route.params.language + 'Description']}}</span>
      </div>
    </div>
    <div v-else>
      <div v-if="premium" class="circle-outline absolute-center premium">
        <div class="absolute-center">
          <IconPlus class="absolute-center"></IconPlus>
        </div>
      </div>
      <div v-else-if="isIconZoom" class="circle-outline absolute-center">
        <div class="dot absolute-center"></div>
        <IconZoom class="absolute-center"></IconZoom>
      </div>
      <div v-else class="circle-outline absolute-center">
        <div class="dot absolute-center"></div>
        <IconPlus class="absolute-center"></IconPlus>
      </div>
    </div>
  </div>
</template>

<script>
import HotspotPulse from './HotspotPulse.vue'
import IconNoAccess from '@/assets/svg/no-access.svg'
import IconPlus from '@/assets/svg/plus-icon.svg'
import IconZoom from '@/assets/svg/zoom.svg'

export default {
  name: 'HotspotHtml',

  props: {
    room: {
      type: Object
    },
    hotspot: {
      type: Object,
      required: false,
      default: null
    },
    position: {
      type: String,
      required: false,
      default: null
    },
    small: {
      type: Boolean
    }
  },

  components: {
    HotspotPulse, IconNoAccess, IconPlus, IconZoom
  },

  data () {
    return {
      showText: false,
      isZoom: false
    }
  },

  mounted () {
    this.checkHotspotVisibility()
  },

  computed: {
    isIconZoom () {
      return this.hotspot._slug === 'zoom'
    },
    premium () {
      let premium = false
      if (this.hotspot.productRef) {
        for (let index = 0; index < this.hotspot.productRef.length; index++) {
          const hs = this.hotspot.productRef[index]
          if (hs.oneOfAKind) {
            premium = true
          }
        }
      }
      return premium
    }
  },

  methods: {
    getRoomFloor () {
      let roomfloor = this.$route.params.floor

      if (this.$root.floors) {
        for (let i = 0; i < this.$root.floors.length; i++) {
          const floor = this.$root.floors[i]
          for (let n = 0; n < floor.rooms.length; n++) {
            const room = floor.rooms[n]
            if (room.roomName._slug === this.$route.params.roomName) {
              roomfloor = floor._slug
              this.currentFloor = floor
            }
          }
        }
      }

      return roomfloor
    },
    onHotspotClick () {
      if (!this.hotspot._slug) return
      if (this.hotspot._slug === 'block') {
        this.showText = true
      } else if (this.hotspot._slug === 'zoom') {
        this.$events.emit('onHotspotZoom', this.position)
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'generic_event',
            eventCategory: 'Clicks on Hotspot Interactions',
            eventAction: this.room.enTitle,
            eventLabel: 'Click on Zoom'
          })
        }
      } else {
        this.currentFloor = this.getRoomFloor()
        let eventAction = ''
        if (this.currentFloor === 'piano-0') eventAction = 'Boutique Ground Floor'
        else if (this.currentFloor === 'piano-1') eventAction = 'Galleria 1° Floor'
        else if (this.currentFloor === 'piano-2') eventAction = 'Galleria 2° Floor'

        if (this.hotspot.productRef) {
          let action = this.hotspot._slug.replace('apr21-', '')
          action = action.replaceAll('-', ' ')
          if (window.dataLayer && this.currentFloor && this.room) {
            window.dataLayer.push({
              event: 'generic_event',
              eventCategory: 'Clicks on Display Hotspot',
              eventAction: action,
              eventLabel: this.room.enTitle
            })
          }
        } else {
          if (window.dataLayer && this.currentFloor && this.room) {
            window.dataLayer.push({
              event: 'generic_event',
              eventCategory: 'Clicks on Hotspot',
              eventAction,
              eventLabel: this.room.enTitle
            })
          }
        }
        this.$router.push({ params: { hotspotContent: this.hotspot._slug } })
      }

      if (this.hotspot._slug.includes('parfum')) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'generic_event',
            eventCategory: 'Clicks on Perfume Hotspot',
            eventAction: this.hotspot.SKU,
            eventLabel: 'Click on Hotspot'
          })
        }
      }

      if (this.hotspot._slug.indexOf('book') > -1) {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'generic_event',
            eventCategory: 'Clicks on Extra CTAs',
            eventAction: 'Bookstore',
            eventLabel: 'Click on Book CTA'
          })
        }
      }
    },
    checkHotspotVisibility () {
      if (this.hotspot.hideForLanguages) {
        if (this.hotspot.hideForLanguages.includes(this.$language.current)) {
          this.$refs.test.classList.add('d-none')
        } else {
          this.$refs.test.classList.remove('d-none')
        }
      }
    }
  },

  watch: {
    $route () {
      this.checkHotspotVisibility()
    }
  }
}
</script>

<style lang="scss" scoped>
.block {
  width: 75px;
  height: 75px;
  border-radius: 75px;
  background-color: $c-light-pink;
}

.block-circle {
  background-color: $c-white !important;
}

.circle {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: $c-light-pink;
}

.circle-outline {
  .dot {
    width: 30px;
    height: 30px;
    border-radius: 20px;
    background-color: $c-light-pink;
    transition: transform 0.5s;
    z-index: 0;
  }

  &::before {
    content: '';
    width: 60px;
    height: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid $c-light-pink;
    border-radius: 30px;
  }

  svg {
    width: 10px;
    height: 10px;
    z-index: 1;
    transition: transform 0.5s;

    path {
      stroke: $c-black;
      stroke-width: 2px;
    }
  }
}

.icon {
  fill: $c-light-pink;
  width: 40px;
  height: 40px;
}

span {
  color: $c-light-pink;
  line-height: 12px;
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 100;
  text-align: center;
}

.hotspot-container {
  position: relative;
  transition: opacity 0.5s;
  cursor: pointer;

  &:hover {
    ::v-deep .pulse {
      opacity: 0;
    }

    svg,
    .dot {
      transform: translate(-50%, -50%) scale(2);
    }
  }
}

.premium {
  background-color: #edd5b7;
  width: 50px;
  height: 50px;
  border-radius: 30px;

  &::before {
    box-shadow: 0 0 20px #edd5b7;
    width: 50px;
    height: 50px;
    border: 1px solid #fff;
  }
}
</style>
